import script from "./chart4.vue?vue&type=script&setup=true&name=chart4&lang=js"
export * from "./chart4.vue?vue&type=script&setup=true&name=chart4&lang=js"

const __exports__ = script;

export default __exports__